import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
	providedIn: 'root'
})

export class ExcelService {

	uploadedFile: any;

	constructor(private readonly ngxUiLoaderService: NgxUiLoaderService) { }
	public exportAsExcelFile(json: any[], excelFileName: string, headers: string[]): void {

		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
		let sheetPro: any = {};
		sheetPro = { Sheets: { 'Sheet1': worksheet }, SheetNames: ['Sheet1'] };


		const range = XLSX.utils.decode_range(worksheet['!ref']);

		//setting "headers" names in excel
		for (let C = range.s.c; C <= range.e.c; C++) {
			const address = XLSX.utils.encode_col(C) + '1'; // <-- first row
			if (!worksheet[address]) {continue;}
			worksheet[address].v = headers[C];
		}
		const wscols = [];
		for (const head of headers) {  // columns length added
			wscols.push({ wch: head.length + 5 });
		}
		worksheet['!cols'] = wscols;


		const workbook: XLSX.WorkBook = sheetPro;
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		this.saveAsExcelFile(excelBuffer, excelFileName);
	}
	private saveAsExcelFile(buffer: any, fileName: string): void {
		const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
		FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
	}

}

